<div class="d-flex align-items-center justify-content-end buttons-container">
    <div class="d-flex ms-3 me-3" *ngFor="let button of buttons; let i = index">
        <mapfre-auditlib-button *ngIf="button.type != 'file'" (click)="onButtonClicked(button)">
            <i *ngIf="button.icon" class="icon" [ngClass]="button.icon"></i>{{button.text | translate}}
        </mapfre-auditlib-button>
        <mapfre-auditlib-button *ngIf="button.type == 'file'" (click)="importExcel()">
            <i *ngIf="button.icon" class="icon" [ngClass]="button.icon"></i>{{button.text | translate}}
        </mapfre-auditlib-button>
        <input *ngIf="button.type == 'file'" type="file" [hidden]="true" (change)="onButtonClicked({key:$event})"
            #inputFile />
    </div>

    <mapfre-auditlib-button *ngIf="filterButton" (click)="filterMode = !filterMode">
        <span *ngIf="filterButton.icon" class="icon"
            [ngClass]="filterButton.icon"></span>{{filterButton.text | translate}}</mapfre-auditlib-button>
    <mapfre-auditlib-button *ngIf="createButton" (click)="create()"><span *ngIf="createButton.icon" class="icon"
            [ngClass]="createButton.icon"></span>{{createButton.text | translate}}</mapfre-auditlib-button>
</div>
<div class="mapfre-table shadow mt-4" [class.collapsed]="collapsed">
    <div class="mapfre table-filter bg-white pl-24 pr-10 py-10" [hidden]="!filterMode">
        <mapfre-auditlib-general-filter [columns]="columns" [src]="body" [filteredData]="bodyFiltered"
            (filteredDataChange)="onFilteredDataChange($event)"></mapfre-auditlib-general-filter>
    </div>
    <div class="mapfre-table-header" *ngIf="!headerTemplate">
        <div class="row h-100">
            <div *ngIf="selectTable" class="col-1"></div>
            <div *ngFor="let col of header" class="align-items-center d-flex"
                [ngClass]="col.class ? col.class + (col.sortable ? ' cursor-pointer' : '') : {'cursor-pointer': col.sortable,'col': !col.class}"
                (click)="onHeaderClick(col)">
                <span [ngClass]="{'me-2': col.sortable}">{{col.name  | translate }}</span>
                <i *ngIf="sortConfig?.key === col.field" class="pi"
                    [ngClass]="sortConfig?.order === 1 ? 'pi-sort-up' : 'pi-sort-down'"></i>
                <i *ngIf="col.sortable && sortConfig?.key !== col.field" class="pi pi-sort"></i>
            </div>
            <div *ngIf="actions || defaultActions?.edit !== false || defaultActions?.delete !== false"
                [ngClass]="'col-1'" class="d-flex align-items-center">
                {{'TABLE.HEADERS.COMMON.ACTIONS' | translate}}</div>
        </div>

    </div>
    <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>

    <div class="mapfre-table-body" *ngIf="!bodyTemplate">
        <div *ngIf="!bodyPaginated?.length">
            <div _ngcontent-wax-c33=""
                class="w-100 d-flex align-items-center justify-content-center bg-white color-greyish py-60 mt-1 opacity-5 ng-star-inserted">
                No hay registros </div>
        </div>
        <div *ngFor="let item of bodyPaginated; let i = index;">
            <mapfre-auditlib-item [nuuma]="nuuma" [actions]="actions" [data]="item" [edit]="item.edit"
                [defaultValidators]="defaultValidators" [columns]="columns" [defaultActions]="defaultActions"
                (actionClicked)="onActionClicked($event,item)" (updated)="onSave($event, item)"
                (selectChange)="onSelectChange($event)" (created)="onCreate($event, item)" (deleted)="onDelete($event)"
                [selectTable]="selectTable" [typeSelect]="typeSelect" [(selectData)]="selectData">
            </mapfre-auditlib-item>
        </div>
    </div>

    <ng-template ngFor let-item [ngForOf]="bodyPaginated">
        <ng-container [ngTemplateOutlet]="bodyTemplate" [ngTemplateOutletContext]="{$implicit:item}"></ng-container>
    </ng-template>
    
    <div class="paginator">
        <mapfre-auditlib-pagination [src]="bodyFiltered" [itemsPerPage]="rowsPerPage" [(paginatedData)]="bodyPaginated">
        </mapfre-auditlib-pagination>
    </div>
</div>